<template>
    <form-element :style="{
    margin: '0 auto',
  }">
        <h2 style="text-align:center">Wertungs&uuml;bersicht</h2>
        <div id="Wertung" style="text-align:center">
            <h2 class="wertungfont">T: {{technik}} / P: {{praesi}}</h2>
        </div>


    </form-element>
</template>
<script>
    import { FormElement } from '@progress/kendo-vue-form';
    import { Button } from '@progress/kendo-vue-buttons';
    import store from '@/store/store.js';

    export default {
        components: {
            'form-element': FormElement,
            'kbutton': Button,
            store
        },
        data: function () {
            return {
                technik: 0,
                praesi: 0,
            };
        },
        mounted() {
            this.getValues();
        },
        created() {

        },
        methods: {
            getValues() {
                this.technik = store.teilnehmer_WertungTechnik;
                this.praesi = store.teilnehmer_WertungPraesentation;
            },
        }
    };
</script>